import api from '.';
import { buildParams } from '../helpers/tableUtil';

class Organization {
  static async getCountries() {
    const organization = await api.get('/organization/countries');
    return organization.data;
  }

  static async getOrganizations({ limit, page, orderData, regionFilter, countryFilter }) {
    const params = buildParams({ limit, page, orderData, regionFilter, countryFilter });
    const organizations = await api.get(`/organization${params}`);
    return organizations.data;
  }

  static async createOrganization(data) {
    const organization = await api.post('/organization', data);
    return organization.data;
  }

  static async getOrganization(id: string) {
    const organization = await api.get(`/organization/${id}`);
    return organization.data;
  }

  static async updateOrganization(id: string, data) {
    delete data.id;
    const organization = await api.put(`/organization/${id}`, data);
    return organization.data;
  }
}

export default Organization;
